export default __webpack_public_path__ + "static/media/process-loading-tablet.0e3950eb.svg";